import React, { useEffect, useState } from 'react'
import { Alert, Button, Fade, FormControl, InputGroup, Modal } from 'react-bootstrap';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';

const url = process.env.REACT_APP_CLA_URL;
const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

function Forgotten() {
    const [state, setState] = useState({ id: '', password: '', confirmPassword: '' });
    const [show, setShow] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const params = new URLSearchParams();
    params.set('opcpm', "UpdatePassword");

    const handleChange = (e) => setState({ ...state, [e.target.name]: e.target.value });
    const handleShow = () => setShow(true)
    const handleClose = () => {
        setShow(false)
        navigate('/')
    }

    const handleSubmit = () => {
        if (state.password.length < 6) {
            setError(true)
        } else if (state.password !== state.confirmPassword) {
            setError(true)
        } else {
            setError(false)
            params.set('id', state.id);
            params.set('passowrd', state.password);
            axios.post(url, params, options)
                .then(r => {
                    //console.log(r)
                    if (r.data.error) {
                        setError(true)
                    } else {
                        setError(false)
                        handleShow()
                    }
                })
        }
    }

    const handleKeyPress = (e) => {
        setError(false)
        e.charCode === 13 && handleSubmit();
    }

    useEffect(() => {
        const dire = window.location.href;
        const id = dire?.split("/").pop();
        setState({ ...state, id });
    }, [])

    return (
        <Fade appear in>
            <div className={'login'}>
                <div className="container max-shadow mt-5">
                    <h1>Reestablecer la contraseña</h1>
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="Contraseña"
                            value={state.password}
                            onChange={handleChange}
                            name="password"
                            type='password'
                            aria-describedby="Password"
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Text id="Password">
                            <FontAwesomeIcon
                                id="Password"
                                icon={faLock}
                                title="Contraseña"
                                aria-label='Contraseña'
                                aria-required={true}
                                aria-describedby='Password'
                            />
                        </InputGroup.Text>
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="Confirmar contraseña"
                            value={state.confirmPassword}
                            onChange={handleChange}
                            name="confirmPassword"
                            type='password'
                            aria-describedby="Confirmar Password"
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Text id="ConfirmPassword">
                            <FontAwesomeIcon
                                id="confirmPassword"
                                icon={faLock}
                                title="Confirmar Contraseña"
                                aria-label='Contraseña'
                                aria-required={true}
                                aria-describedby='Confirmar Password'
                            />
                        </InputGroup.Text>
                    </InputGroup>
                    {
                        error &&
                        <Alert className='mt-2' variant={'danger'}>
                            <p>La clave debe coincidir y tener al menos 6 caracteres</p>
                        </Alert>
                    }
                    <Button onClick={handleSubmit}>Confirmar</Button>
                </div>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Listo!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Contraseña reestablecida exitosamente.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose} className="main-btn">
                            Volver
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </Fade>
    )
}

export default Forgotten